/* TRVL redesign — keeps the cart drawer gift bar and add-on suggestion in sync with the cart. */
(function () {
  'use strict';
  var timer;
  var money = function (cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, (cents / 100).toFixed(2));
  };
  function apply(cart) {
    document.querySelectorAll('[data-trvl-cart-gift]').forEach(function (el) {
      var t = +el.dataset.threshold || 0; if (!t) return;
      var left = t - cart.total_price;
      var msg = el.querySelector('[data-gift-msg]'), fill = el.querySelector('[data-gift-fill]');
      if (msg) msg.innerHTML = left > 0 ? el.dataset.more.replace('[amount]', '<strong>' + money(left) + '</strong>') : el.dataset.done;
      if (fill) fill.style.width = Math.min(100, Math.round(cart.total_price / t * 100)) + '%';
    });
    document.querySelectorAll('[data-trvl-cart-upsell]').forEach(function (el) {
      var id = +el.dataset.productId;
      el.hidden = cart.items.some(function (i) { return i.product_id === id; }) || cart.item_count === 0;
    });
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(apply).catch(function () {});
    }, 350);
  }
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'cart:open'].forEach(function (ev) { document.addEventListener(ev, refresh); });
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('#CartDrawer')) refresh(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#CartDrawer [data-products]')) refresh(); });
})();
